module.exports = __webpack_public_path__ + "img/Granit Xhaka.12034f58.png";